import { ActivityServicePath } from "utils/constants";

export const activityRequests = {
  studentForeignLanguageSchedule: educationId => `${ActivityServicePath}students/${educationId}/foreign-languages`,

  studentSportActivities: educationId => `${ActivityServicePath}students/${educationId}/sports/activities`,
  deleteStudentSportActivity: (educationId, sportActivityId) =>
    `${ActivityServicePath}students/${educationId}/sports/activities/${sportActivityId}`,

  entryTestStudentsByForeignLanguage: foreignLanguageId =>
    `${ActivityServicePath}students/foreign-languages/${foreignLanguageId}/levels/assignments`,
  manageEntryTestStudentAssignments: () => `${ActivityServicePath}students/foreign-languages/levels/assignments`,
  importEntryTestResults: foreignLanguageId =>
    `${ActivityServicePath}foreign-languages/${foreignLanguageId}/entry-tests/results/import`,
  getEntryTestResultsTemplate: () => `${ActivityServicePath}foreign-languages/entry-tests/results/import/template`,

  getActivityForeignLanguagesLevelsSelect: () => `${ActivityServicePath}foreign-languages/levels/select`,
  getActivityForeignLanguageLevelsByLanguageSelect: foreignLanguageId =>
    `${ActivityServicePath}foreign-languages/${foreignLanguageId}/levels/select`,
  getActivityForeignLanguagesSelect: () => `${ActivityServicePath}foreign-languages/select`,
  getActivitySportSelect: () => `${ActivityServicePath}sports/select`,
};
